(function () {
  'use strict';

  var ui = JSON.parse(document.getElementById('us-ui-strings').textContent);
  var storageKey = 'us-location-id';
  var preferredId = '';
  var dialog = document.getElementById('us-location-dialog');
  var returnFocus = null;
  var locationCards = Array.from(document.querySelectorAll('[data-us-card]'));

  function normalized(value) {
    return String(value || '').toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }

  function preferredCard(id) {
    return locationCards.find(function (card) { return card.dataset.usCard === id; });
  }

  function reflectSelection() {
    var selectedCard = preferredCard(preferredId);
    var label = selectedCard ? selectedCard.dataset.usLabel : ui.choose;
    document.querySelectorAll('[data-us-current-location]').forEach(function (element) {
      element.textContent = label;
    });
    locationCards.forEach(function (card) {
      var selected = card.dataset.usCard === preferredId;
      card.classList.toggle('us-location-card--selected', selected);
      var button = card.querySelector('[data-us-select]');
      if (button) {
        button.setAttribute('aria-pressed', String(selected));
        var text = button.querySelector('[data-us-selection-label]');
        if (text) text.textContent = selected ? ui.mine : ui.makeMine;
      }
    });
  }

  try {
    var storedId = window.localStorage.getItem(storageKey);
    if (storedId && preferredCard(storedId)) preferredId = storedId;
  } catch (error) {
    
  }

  document.querySelectorAll('[data-us-locations]').forEach(function (container) {
    var requestedRegion = new URLSearchParams(window.location.search).get('region');
    var regionMap = {California:'CA', Texas:'TX', Maryland:'MD', Minnesota:'MN'};
    var region = container.closest('dialog') ? 'all' : (regionMap[requestedRegion] || 'all');
    var search = container.querySelector('[data-us-search]');
    var count = container.querySelector('[data-us-results]');
    var empty = container.querySelector('[data-us-empty]');
    var cards = Array.from(container.querySelectorAll('[data-us-card]'));
    var controls = Array.from(container.querySelectorAll('button[data-us-region]'));

    function filterCards() {
      var terms = normalized(search ? search.value : '').split(/\s+/).filter(Boolean);
      var visible = 0;
      cards.forEach(function (card) {
        var haystack = normalized(card.dataset.usSearch || card.textContent);
        var matches = (region === 'all' || card.dataset.usRegion === region) && terms.every(function (term) {
          return haystack.indexOf(term) !== -1;
        });
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      container.querySelectorAll('[data-us-group]').forEach(function (group) {
        group.hidden = !Array.from(group.querySelectorAll('[data-us-card]')).some(function (card) { return !card.hidden; });
      });
      if (count) count.textContent = visible + (visible === 1 ? ui.one : ui.many);
      if (empty) empty.hidden = visible !== 0;
      controls.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.usRegion === region));
      });
    }

    controls.forEach(function (button) {
      button.addEventListener('click', function () {
        region = button.dataset.usRegion;
        filterCards();
      });
    });
    if (search) search.addEventListener('input', filterCards);
    container.querySelectorAll('[data-us-clear-search]').forEach(function (button) {
      button.addEventListener('click', function () {
        region = 'all';
        if (search) search.value = '';
        filterCards();
        if (search) search.focus();
      });
    });
    container.querySelectorAll('[data-us-enhancement]').forEach(function (element) { element.hidden = false; });
    filterCards();
  });

  document.querySelectorAll('[data-us-select]').forEach(function (button) {
    button.addEventListener('click', function () {
      var id = button.dataset.usSelect;
      if (!preferredCard(id)) return;
      preferredId = id;
      try { window.localStorage.setItem(storageKey, id); } catch (error) {  }
      reflectSelection();
      var selectedCard = preferredCard(id);
      document.querySelectorAll('[data-us-selection-announcement]').forEach(function (element) {
        element.textContent = selectedCard.dataset.usLabel + ui.selected;
      });
    });
  });

  function closeDialog() {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }

  if (dialog && typeof dialog.showModal === 'function') {
    document.querySelectorAll('[data-us-order]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        returnFocus = button;
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('us-dialog-open');
        var search = dialog.querySelector('[data-us-search]');
        if (search) search.focus();
      });
    });
    dialog.querySelectorAll('[data-us-close]').forEach(function (button) { button.addEventListener('click', closeDialog); });
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('us-dialog-open');
      if (returnFocus && returnFocus.isConnected) returnFocus.focus();
    });
    
  }

  reflectSelection();
}());
